<template>
  <div>
    <!-- Slot for mobile view -->
    <div v-if="isMobile">
      <slot name="mobile"></slot>
    </div>

    <!-- Slot for desktop view -->
    <div v-else>
      <slot name="desktop"></slot>
    </div>
  </div>
</template>

<script>
  import { responsiveMixin } from "@/mixins/responsiveMixin"

  export default {
    name: "ResponsiveComponent",
    mixins: [responsiveMixin],
  }
</script>
